import { IExtendedFormDataResponse, IRequestParams, IResponse } from '@dash/apiInstance';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { sendRequest } from 'src/helpers/saga';
import notifications from 'src/redux/notifications/actions';
import { logger } from 'src/helpers/logger';
import ApiInstance from 'src/helpers/apiInstance';
import { t } from 'src/i18n';
import actions from './actions';
import { IFormData } from './types';
import actionTypes from './actionTypes';
import { UploadTrustedTalentAction } from './actions.d';

const API_ROOT = 'applicants/trusted/import';

const formDataApi = new ApiInstance(`${API_ROOT}/form_data`);
const templateApi = new ApiInstance(`${API_ROOT}/template`);
const uploadApplicantApi = new ApiInstance(API_ROOT);

function* loadFormData() {
  try {
    const result: IExtendedFormDataResponse<IFormData> = yield call<any, IRequestParams<{}, {}>, string>(
      sendRequest,
      formDataApi.get,
      {},
      notifications.REQUEST_ERROR,
    );

    if (result.status === 200 && result.data) {
      yield put(actions.loadFormDataSuccess({ data: result.data }));
    } else {
      yield put(actions.loadFormDataError());
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadTemplate() {
  try {
    const result: IResponse<any> = yield call<any, IRequestParams<{}, {}>, string>(
      sendRequest,
      templateApi.get,
      {},
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      yield put(actions.loadTemplateSuccess());
      const { fileBlobUrl, fileName } = result.data;

      const link = document.createElement('a');
      link.href = fileBlobUrl;
      link.target = '_blank';
      link.download = fileName || 'trusted_talent_template.csv';
      link.click();

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.exported_successfully', {
            item: t('dash.applicants.upload_trusted_talent_modal.trusted_talent_applicants_template_label'),
          }),
        }),
      );
    } else {
      yield put(actions.loadTemplateError());
    }
  } catch (error) {
    logger.error(error);
  }
}

function* uploadTrustedTalent({ payload }: UploadTrustedTalentAction) {
  try {
    const result: IResponse<any> = yield call<any, IRequestParams<{}, {}>, string>(
      sendRequest,
      uploadApplicantApi.post,
      { data: payload },
      notifications.REQUEST_ERROR,
    );

    if (result.status === 200) {
      yield put(actions.uploadTrustedTalentSuccess());
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.imported_successfully', {
            item: t('dash.applicants.select_applicant_modal.trusted_talent_applicant_label'),
          }),
        }),
      );
    } else {
      yield put(actions.uploadTrustedTalentError());
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.LOAD_FORM_DATA, loadFormData)]);
  yield all([takeEvery(actionTypes.LOAD_TEMPLATE, loadTemplate)]);
  yield all([takeEvery(actionTypes.UPLOAD_TRUSTED_TALENT, uploadTrustedTalent)]);
}
